import React from "react";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
} from "recharts";
import {
  sortByDesignerAndMonthYear,
  sortByMonthAndYear,
} from "../../util/sortCart";

function Chart({ manager, text }) {
  //console.log(manager);
  let monthlyData = [];
  if (manager.length !== 0) monthlyData = sortByDesignerAndMonthYear(manager);
  console.log(monthlyData);
  return (
    <div className="">
      <div>
        {/* <div className="text-[#9E9E9E]  py-2 px-6">{text}</div> */}
        <div className="  w-[97%] h-[300px] m-auto mt-[20px]">
          <ResponsiveContainer>
            <AreaChart
              // width={950}
              // height={height}
              data={monthlyData}
              // margin={{ top: 15 }}
            >
              <defs>
                <linearGradient id="Ira" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#739D00" stopOpacity={0.9} />
                  <stop offset="95%" stopColor="#739D00" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="Nati" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#ffc658" stopOpacity={0.9} />
                  <stop offset="95%" stopColor="#ffc658" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="Shahar" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#0088fe" stopOpacity={0.9} />
                  <stop offset="95%" stopColor="#0088fe" stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis dataKey="name" stroke="gray" />
              <CartesianGrid
                strokeDasharray="3 3"
                className="stroke-[#9c9a9a]"
              />
              <Tooltip />
             
              <Area
                type="monotone"
                dataKey="Ira"
                stroke="#739D00"
                fillOpacity={1}
                fill="url(#Ira)"
              />
              <Area
                type="monotone"
                dataKey="Nati"
                
                stroke="#ffc658"
                fill="url(#Nati)"
              />
               {/* <Area
                type="monotone"
                dataKey="Shahar"
                
                stroke="#0088fe"
                fill="url(#Shahar)"
              /> */}
              <Area
                type="monotone"
                dataKey="Ruti"
                
                stroke="#00ff00"
                fill="url(#Ruti)"
              />
              
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}

export default Chart;
